import styled from '@emotion/styled';
import { Box as MuiBox } from '@mui/material';

export const FormStyle = styled(MuiBox)`
  ${() => `
    padding-top: 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-Items: center;
    position: relative;
    height: calc(100vh - 24rem);
  `}
`;

export const LabelStyle = styled(MuiBox)`
  ${() => `
    height: 150px;
  `}
`;
